module.exports = __webpack_public_path__ + "img/img1.5a2a9e01.jpg";